module.exports = __webpack_public_path__ + "static/media/screen-component-sampler.6e1ba9e0.jpg";